module.exports = __webpack_public_path__ + "static/chart-breakdown-min-d64f915226c1f6965c15b60245015ae9.png";